module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-4-ec6648157d11393189ef21df87701a0a.jpg";